export const dateFormatView = 'DD.MM.YYYY';

export const timeFormatsView = {
    short: 'HH:mm',
    extended: 'HH:mm:ss',
};

export const dateTimeFormatsView = {
    short: dateFormatView + ' ' + timeFormatsView.short,
    extended: dateFormatView + ' ' + timeFormatsView.extended,
};

export const dayFormatsView = {
    short: 'dd, ',
    extended: 'dddd, ',
};

export const preferredDateFormatInternally = 'YYYY-MM-DD';
export const preferredTimeFormatInternally = 'HH:mm:ss';
export const preferredDateTimeFormatInternally = 'YYYY-MM-DDTHH:mm:ssZ';

export const dateFormatsInternally = [
    preferredDateFormatInternally,
    preferredDateTimeFormatInternally,
    dateFormatView,
    dateTimeFormatsView.short,
    dateTimeFormatsView.extended,
];

export const timeFormatsInternally = [
    preferredTimeFormatInternally,
    preferredDateTimeFormatInternally,
    timeFormatsView.short,
    timeFormatsView.extended,
    dateTimeFormatsView.short,
    dateTimeFormatsView.extended,
];

export const dateTimeFormatsInternally = [
    preferredDateTimeFormatInternally,
    dateTimeFormatsView.short,
    dateTimeFormatsView.extended,
];
